import { Colors } from '@zapier/design-system';

export const COLOR_KEYS = Object.keys(Colors).reduce((obj, key) => {
  return { ...obj, [key]: key };
}, {}) as { [key in keyof typeof Colors]: key };

export enum SEMANTIC_COLORS {
  danger = 'danger',
  primary = 'primary',
  primaryAlt = 'primary-alt',
  secondary = 'secondary',
  tertiary = 'tertiary',
}

export const COLOR_KEYS_LIST = Object.values(COLOR_KEYS).sort();

export const BACKGROUND_TO_FONT_COLORS = {
  [COLOR_KEYS.acidWash]: Colors.neutral800,
  [COLOR_KEYS.bolt]: Colors.neutral800,
  [COLOR_KEYS.cream]: Colors.neutral800,
  [COLOR_KEYS.earth]: Colors.neutral100,
  [COLOR_KEYS.gray]: Colors.neutral800,
  [COLOR_KEYS.lavender]: Colors.neutral800,
  [COLOR_KEYS.moss]: Colors.neutral100,
  [COLOR_KEYS.neutral100]: Colors.neutral800,
  [COLOR_KEYS.neutral800]: Colors.neutral100,
  [COLOR_KEYS.night]: Colors.neutral100,
  [COLOR_KEYS.peach]: Colors.neutral800,
  [COLOR_KEYS.sky]: Colors.neutral800,
  [COLOR_KEYS.transparent]: Colors.neutral800,
  [COLOR_KEYS.zapier]: Colors.neutral100,
};

export const LIGHT_BACKGROUND_COLORS = [
  COLOR_KEYS.acidWash,
  COLOR_KEYS.bolt,
  COLOR_KEYS.cream,
  COLOR_KEYS.neutral200,
  COLOR_KEYS.lavender,
  COLOR_KEYS.neutral100,
  COLOR_KEYS.peach,
  COLOR_KEYS.sky,
  COLOR_KEYS.transparent,
];

export const BACKGROUND_COLOR_KEYS = Object.keys(
  BACKGROUND_TO_FONT_COLORS,
).sort();

const FONT_COLORS = Object.values(BACKGROUND_TO_FONT_COLORS);

export type BackgroundColorKey =
  | typeof COLOR_KEYS.acidWash
  | typeof COLOR_KEYS.bolt
  | typeof COLOR_KEYS.bolt
  | typeof COLOR_KEYS.cream
  | typeof COLOR_KEYS.earth
  | typeof COLOR_KEYS.gray
  | typeof COLOR_KEYS.lavender
  | typeof COLOR_KEYS.neutral100
  | typeof COLOR_KEYS.neutral800
  | typeof COLOR_KEYS.night
  | typeof COLOR_KEYS.peach
  | typeof COLOR_KEYS.sky
  | typeof COLOR_KEYS.transparent
  | typeof COLOR_KEYS.zapier;

export type FontColor = typeof FONT_COLORS[number];

export const SEMANTIC_COLORS_LIST = Object.values(SEMANTIC_COLORS).sort();

export type SemanticColor = typeof SEMANTIC_COLORS_LIST[number];
